export const laborLawConst = {
  path: "/single-programs/labor-law",
  title: "ФАКУЛЬТЕТ ПРАВА — ТРУДОВОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Трудовое право — правовая защита труда и баланса интересов</h2>
      <p>
        Современный рынок труда требует грамотных специалистов, способных обеспечить законность трудовых отношений и защиту прав работников
        и работодателей. Программа по трудовому праву охватывает все ключевые аспекты: от найма и увольнения до разрешения трудовых
        конфликтов и соблюдения норм охраны труда.
      </p>
      <p>
        Это направление сочетает юридические знания с практическими навыками, необходимыми для работы в компаниях, госорганах, профсоюзах и
        HR-структурах.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общие принципы трудового права</li>
        <li>Договоры о найме и трудовые контракты</li>
        <li>Права и обязанности сторон трудовых отношений</li>
        <li>Законодательство об охране труда и безопасности</li>
        <li>Разрешение трудовых споров и медиация</li>
        <li>Коллективное право и профсоюзы</li>
        <li>Правовое регулирование занятости в ЕС</li>
        <li>Влияние трудового законодательства на HR-политику</li>
      </ul>
      <p>
        Программа ориентирована на практику: вы научитесь анализировать трудовые договоры, сопровождать процедуры увольнения и разрабатывать
        внутренние корпоративные политики.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Юрист по трудовому праву в компании или юридической фирме</li>
        <li>Специалист по трудовым отношениям</li>
        <li>HR-консультант по правовым вопросам</li>
        <li>Эксперт по охране труда и внутренним регламентам</li>
        <li>Представитель в трудовых судах или профсоюзах</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €90,000 в год</strong> — особенно в международных компаниях и юридических департаментах.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, соответствующий стандартам ЕС</li>
        <li>Обучение на русском или английском языке</li>
        <li>Очная или дистанционная форма — удобно для совмещения с работой</li>
        <li>Практическая направленность и актуальные кейсы</li>
        <li>Поддержка стажировок и карьерного старта</li>
        <li>Доступ к правовым ресурсам ЕС и консультациям экспертов</li>
      </ul>
      <p>Трудовое право — это профессия, где правовая грамотность помогает строить справедливые и эффективные отношения в команде.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на всех этапах: от подачи заявки до начала обучения.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Трудовое право — правовая защита труда и баланса интересов
    Современный рынок труда требует грамотных специалистов, способных обеспечить законность трудовых отношений и защиту прав работников и работодателей. Программа по трудовому праву охватывает все ключевые аспекты: от найма и увольнения до разрешения трудовых конфликтов и соблюдения норм охраны труда.
    Это направление сочетает юридические знания с практическими навыками, необходимыми для работы в компаниях, госорганах, профсоюзах и HR-структурах.
    Что вы будете изучать?
    • Общие принципы трудового права
    • Договоры о найме и трудовые контракты
    • Права и обязанности сторон трудовых отношений
    • Законодательство об охране труда и безопасности
    • Разрешение трудовых споров и медиация
    • Коллективное право и профсоюзы
    • Правовое регулирование занятости в ЕС
    • Влияние трудового законодательства на HR-политику
    Программа ориентирована на практику: вы научитесь анализировать трудовые договоры, сопровождать процедуры увольнения и разрабатывать внутренние корпоративные политики.
    Кем можно работать после окончания?
    • Юрист по трудовому праву в компании или юридической фирме
    • Специалист по трудовым отношениям
    • HR-консультант по правовым вопросам
    • Эксперт по охране труда и внутренним регламентам
    • Представитель в трудовых судах или профсоюзах
    Зарплата в Европе: от €45,000 до €90,000 в год — особенно в международных компаниях и юридических департаментах.
    Почему выбирают нас?
    • Европейский диплом, соответствующий стандартам ЕС
    • Обучение на русском или английском языке
    • Очная или дистанционная форма — удобно для совмещения с работой
    • Практическая направленность и актуальные кейсы
    • Поддержка стажировок и карьерного старта
    • Доступ к правовым ресурсам ЕС и консультациям экспертов
    Трудовое право — это профессия, где правовая грамотность помогает строить справедливые и эффективные отношения в команде.
    Как поступить? 
    Приёмная комиссия сопровождает вас на всех этапах: от подачи заявки до начала обучения. 
  `,
};
